import { render } from "./ExternalLink.vue?vue&type=template&id=046a2963"
import script from "./ExternalLink.vue?vue&type=script&lang=js"
export * from "./ExternalLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__